import React from 'react';
import PropTypes from 'prop-types';
import { getDate } from '../common/HelperFunctions';
import Link from '../common/Link';

const NewsItem = ({ preview, date, image, permalink, title }) => {
  const customImage = image?.fields?.file?.url;
  return (
    <div className="news-wrapper col-sm-6" style={{}}>
      <div className="news-item">
        <div className="news-header" style={{}}>
          <Link to={`/news/${permalink}`}>
            <div
              className="news-image"
              style={customImage && { backgroundImage: `url(${customImage})` }}
            />
            <h2 className="title">{title}</h2>
          </Link>
        </div>
        <div className="content">
          <p className="date clearfix">
            <span className="pull-right">
              <span className="icon-calendar" /> {getDate(date)}
            </span>
          </p>
          <p className="text">{preview}</p>
          <div className="read-more">
            <p>
              <Link to={`/news/${permalink}`}>Read Full Article</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

NewsItem.propTypes = {
  article: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  image: PropTypes.string,
  permalink: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default NewsItem;
